'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'notebook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e201';
var svgPathData = 'M416 0H128C92.65 0 64 28.65 64 64v32H24C10.75 96 0 106.8 0 120S10.75 144 24 144H64v88H24C10.75 232 0 242.8 0 256s10.75 24 24 24H64v88H24C10.75 368 0 378.8 0 392S10.75 416 24 416H64v32c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64V64C480 28.65 451.3 0 416 0zM112 448v-32h24C149.3 416 160 405.3 160 392S149.3 368 136 368H112V280h24C149.3 280 160 269.3 160 256S149.3 232 136 232H112V144h24C149.3 144 160 133.3 160 120S149.3 96 136 96H112V64c0-8.838 7.164-16 16-16h64v416H128C119.2 464 112 456.8 112 448zM432 448c0 8.836-7.164 16-16 16H240v-416H416c8.836 0 16 7.162 16 16V448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNotebook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;